import { useForm } from "react-hook-form";
import { interviewQuestionService } from "../../service/InterviewQuestion/interviewQuestion.service";
import InterviewQuestionForm from "./_interviewQuestionForm";
import {
  IInterviewQuestionCreateProps,
  IInterviewQuestionFormInput,
} from "./InterviewQuestion.model";
import { useAuthContext } from "../../context/AuthContext";

const InterviewQuestionCreate = ({
  setQuestionDialog,
  loadInterviewQuestions,
}: IInterviewQuestionCreateProps) => {
  const authContext = useAuthContext();
  const currentUser = authContext?.currentUser;

  const methods = useForm<IInterviewQuestionFormInput>({
    mode: "onSubmit",
    defaultValues: {
      user: currentUser?.id || 0,
      question_text: "",
      topic: 0,
      difficulty_level: 1,
      is_active: true,
      choices: [
        { choice_text: "", is_correct: false },
        { choice_text: "", is_correct: false },
        { choice_text: "", is_correct: false },
        { choice_text: "", is_correct: false },
      ],
    },
  });

  const { setError } = methods;

  const onSubmit = async (data: IInterviewQuestionFormInput) => {
    try {
      data.user = currentUser?.id || 0;
      await interviewQuestionService.create(data);
      loadInterviewQuestions();
      setQuestionDialog(false);
    } catch (err: any) {
      if (err.response?.data) {
        const errors = err.response.data;

        Object.keys(errors).forEach((key) => {
          setError(key as keyof IInterviewQuestionFormInput, {
            type: "server",
            message: Array.isArray(errors[key]) ? errors[key][0] : errors[key],
          });
        });
      }
    }
  };

  return (
    <InterviewQuestionForm
      methods={methods}
      onSubmit={onSubmit}
      isEdit={false}
    />
  );
};

export default InterviewQuestionCreate;
